export const AUTH_SIGN_UP = 'AUTH_SIGN_UP';
export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_LINK_GOOGLE = 'AUTH_LINK_GOOGLE';
export const AUTH_UNLINK_GOOGLE = 'AUTH_UNLINK_GOOGLE';
export const GOOGLE_SIGN_IN = 'GOOGLE_SIGN_IN';
export const GOOGLE_SIGN_OUT = 'GOOGLE_SIGN_OUT';

export const AUTH_ERROR = 'AUTH_ERROR';
export const DASHBOARD_GET_DATA = 'DASHBOARD_GET_DATA';
export const MESSAGELOG_DATA = 'MESSAGELOG_DATA';
export const MESSAGELOG_DATA_AGR_DEVICE = 'MESSAGELOG_DATA_AGR_DEVICE';
export const MESSAGELOG_DATA_AGR_CUSTOMER = 'MESSAGELOG_DATA_AGR_CUSTOMER';
export const MESSAGELOG_DATA_AGR_CUSTOMER_START = 'MESSAGELOG_DATA_AGR_CUSTOMER_START';
export const MESSAGELOG_DATA_AGR_DEVICE_DATA = 'MESSAGELOG_DATA_AGR_DEVICE_DATA';
export const MESSAGELOG_DATA_DETAILED_DATA_START = 'MESSAGELOG_DATA_DETAILED_DATA_START';
export const MESSAGELOG_DATA_READBLOB = 'MESSAGELOG_DATA_READBLOB';
export const MESSAGELOG_DATA_READBLOB_START = 'MESSAGELOG_DATA_READBLOB_START';
export const MESSAGELOG_DATA_SETLOADER = 'MESSAGELOG_DATA_SETLOADER';

export const CUSTOMER_ADD = 'CUSTOMER_ADD';
export const CUSTOMER_EDIT = 'CUSTOMER_EDIT';
export const CUSTOMER_DATA = 'CUSTOMER_DATA';
export const CUSTOMER_ADD_LOADER = 'CUSTOMER_ADD_LOADER';
export const CUSTOMER_TOGGLE_ACTIVE = 'CUSTOMER_TOGGLE_ACTIVE';
export const CUSTOMER_DELETED = 'CUSTOMER_DELETED';
export const CUSTOMER_SERVER_DATA = 'CUSTOMER_SERVER_DATA';
export const CUSTOMER_RESET_SUCCESS = 'CUSTOMER_RESET_SUCCESS';
export const SERVER_ADD_LOADER = 'SERVER_ADD_LOADER';
export const SERVER_DATA = 'SERVER_DATA';
export const SERVER_ADD = 'SERVER_ADD';
export const SERVER_EDIT = 'SERVER_EDIT';
export const SERVER_TOGGLE_ACTIVE = 'SERVER_TOGGLE_ACTIVE';
export const SERVER_DELETED = 'SERVER_DELETED';
export const SERVER_RESET_SUCCESS = 'SERVER_RESET_SUCCESS';
export const USER_DATA = 'USER_DATA';
export const USER_ADD = 'USER_ADD';
export const USER_EDIT = 'USER_EDIT';
export const USER_ADD_LOADER = 'USER_ADD_LOADER';
export const USER_DELETED = 'USER_DELETED';
export const USER_RESET_SUCCESS = 'USER_RESET_SUCCESS';
export const USER_DATA_BY_ROLE = 'USER_DATA_BY_ROLE';